import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

import { AlertService } from '../../services/alert.service';
import { CommunityService } from '../../services/community.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'community-message-card',
    templateUrl: './community-message-card.component.html',
    styleUrls: ['./community-message-card.component.scss']
})
export class CommunityMessageCardComponent implements OnInit, OnDestroy {

    @Input()
    message: any;

    @Output('commentClick')
    commentClickEventEmitter = new EventEmitter<void>();

    @Output('photoClick')
    photoClickEventEmitter = new EventEmitter<string>();

    @Output('updateUser')
    updateUserEventEmitter = new EventEmitter<any>();

    constructor(

        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private communityService: CommunityService
    ) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    updateUserBanned(banned: boolean) {
        console.log('CommunityMessageCardComponent.updateUserBanned.user.id', this.message.user.id);
        this.progressIndicatorService.progress = true;
        this.communityService.updateUserBanned(this.message.user.id, banned).subscribe({
            next: (value: any) => {
                console.log('CommunityMessageCardComponent.updateUserBanned.communityService.updateUserBanned.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.message.user.banned = banned;
                this.updateUserEventEmitter.emit(this.message.user);
            },
            error: (error: any) => {
                console.log('CommunityMessageCardComponent.updateUserBanned.communityService.updateUserBanned.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    messageDeletedControlChange(deleted: string) {
        console.log('CommunityMessageCardComponent.messageDeletedControlChange.deleted', deleted);
        this.progressIndicatorService.progress = true;
        this.communityService.updateMessageDeleted(this.message.id, deleted).subscribe({
            next: (value: any) => {
                console.log('CommunityMessageCardComponent.messageDeletedControlChange.communityService.updateMessageDeleted.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.message.deleted = deleted == 'true' ? true : deleted == 'false' ? false : null;
            },
            error: (error: any) => {
                console.log('CommunityMessageCardComponent.messageDeletedControlChange.communityService.updateMessageDeleted.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    messageInappropriateControlChange(inappropriate: string) {
        console.log('CommunityMessageCardComponent.messageInappropriateControlChange.inappropriate', inappropriate);
        this.progressIndicatorService.progress = true;
        this.communityService.updateMessageInappropriate(this.message.id, inappropriate).subscribe({
            next: (value: any) => {
                console.log('CommunityMessageCardComponent.messageInappropriateControlChange.communityService.updateMessageInappropriate.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.message.inappropriate = inappropriate == 'true' ? true : inappropriate == 'false' ? false : null;
            },
            error: (error: any) => {
                console.log('CommunityMessageCardComponent.messageInappropriateControlChange.communityService.updateMessageInappropriate.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    likeButtonClick() {
        if (!this.message.isInLikes) {
            this.likeMessage();
        } else {
            this.unlikeMessage();
        }
    }

    likeMessage() {
        this.message.likeInProgress = true;
        this.message.isInLikes = true;
        this.message.numLikes += 1;
        this.communityService.likeMessage(this.message.id).subscribe({
            next: (value: any) => {
                console.log('CommunityMessageCardComponent.likeMessage.communityService.likeMessage.value', value);
                this.message.likeInProgress = false;
                this.updateMessage();
            },
            error: (error: any) => {
                console.log('CommunityMessageCardComponent.likeMessage.communityService.likeMessage.error', error);
                this.message.likeInProgress = false;
            }
        });
    }

    unlikeMessage() {
        this.message.likeInProgress = true;
        this.message.isInLikes = false;
        this.message.numLikes -= 1;
        this.communityService.unlikeMessage(this.message.id).subscribe({
            next: (value: any) => {
                console.log('CommunityMessageCardComponent.unlikeMessage.communityService.unlikeMessage.value', value);
                this.message.likeInProgress = false;
                this.updateMessage();
            },
            error: (error: any) => {
                console.log('CommunityMessageCardComponent.unlikeMessage.communityService.unlikeMessage.error', error);
                this.message.likeInProgress = false;
            }
        });
    }

    updateMessage() {
        this.communityService.getMessage(this.message.id).subscribe({
            next: (value: any) => {
                console.log('CommunityMessageCardComponent.updateMessage.communityService.updateMessage.value', value);
                this.message.numLikes = value.numLikes;
                this.message.numComments = value.numComments;
                this.message.numReports = value.numReports;
                this.message.isInLikes = value.isInLikes;
                this.message.isInComments = value.isInComments;
                this.message.deleted = value.deleted;
                this.message.inappropriate = value.inappropriate;
            },
            error: (error: any) => {
                console.log('CommunityMessageCardComponent.updateMessage.communityService.updateMessage.error', error);
            }
        });
    }

    emitCommentClickEvent() {
        this.commentClickEventEmitter.emit();
    }

    emitPhotoClickEvent() {
        this.photoClickEventEmitter.emit(this.message.photo.path);
    }
}
